import type { RequestDetailViewState } from "./request-detail-view-types";
import { RequestOfferList } from "./RequestOfferList";
import { RequestOfferComposer } from "./RequestOfferComposer";
import { FileText, Plus, X } from "lucide-react";

type Props = Pick<
  RequestDetailViewState,
  | "detail"
  | "setPreviewAttachment"
  | "openOfferDocumentsId"
  | "setOpenOfferDocumentsId"
  | "offerComposerOpen"
  | "suppliersLoading"
  | "savingOffer"
  | "editingOfferId"
  | "pendingOfferRemovalId"
  | "setPendingOfferRemovalId"
  | "removingOfferId"
  | "offerFormError"
  | "offerDocument"
  | "setOfferDocument"
  | "extraCostsOpen"
  | "setExtraCostsOpen"
  | "offerForm"
  | "setOfferForm"
  | "supplierAutocompleteOptions"
  | "directOfferTotal"
  | "deliveryWarning"
  | "duplicateSupplierOffer"
  | "openOfferComposer"
  | "openOfferEditor"
  | "closeOfferComposer"
  | "saveDirectOffer"
  | "removeOffer"
  | "comparison"
  | "getOfferAttachments"
  | "canManageOffers"
>;
export function RequestOffersPanel({
  detail,
  setPreviewAttachment,
  openOfferDocumentsId,
  setOpenOfferDocumentsId,
  offerComposerOpen,
  suppliersLoading,
  savingOffer,
  editingOfferId,
  pendingOfferRemovalId,
  setPendingOfferRemovalId,
  removingOfferId,
  offerFormError,
  offerDocument,
  setOfferDocument,
  extraCostsOpen,
  setExtraCostsOpen,
  offerForm,
  setOfferForm,
  supplierAutocompleteOptions,
  directOfferTotal,
  deliveryWarning,
  duplicateSupplierOffer,
  openOfferComposer,
  openOfferEditor,
  closeOfferComposer,
  saveDirectOffer,
  removeOffer,
  comparison,
  getOfferAttachments,
  canManageOffers,
}: Props) {
  return <section className="detail-card detail-offers-card">
              <div className="detail-card-title">
                <FileText size={17} />
                <div>
                  <strong>Teklif karşılaştırması</strong>
                </div>
                {canManageOffers ? (
                  <button
                    className="detail-offer-add"
                    type="button"
                    onClick={() =>
                      offerComposerOpen
                        ? closeOfferComposer()
                        : void openOfferComposer()
                    }
                  >
                    {offerComposerOpen ? <X size={14} /> : <Plus size={14} />}
                    {offerComposerOpen ? "Formu kapat" : "Teklif ekle"}
                  </button>
                ) : null}
              </div>
              <RequestOfferComposer
                detail={detail}
                offerComposerOpen={offerComposerOpen}
                suppliersLoading={suppliersLoading}
                savingOffer={savingOffer}
                editingOfferId={editingOfferId}
                removingOfferId={removingOfferId}
                offerFormError={offerFormError}
                offerDocument={offerDocument}
                setOfferDocument={setOfferDocument}
                extraCostsOpen={extraCostsOpen}
                setExtraCostsOpen={setExtraCostsOpen}
                offerForm={offerForm}
                setOfferForm={setOfferForm}
                supplierAutocompleteOptions={supplierAutocompleteOptions}
                directOfferTotal={directOfferTotal}
                deliveryWarning={deliveryWarning}
                duplicateSupplierOffer={duplicateSupplierOffer}
                closeOfferComposer={closeOfferComposer}
                saveDirectOffer={saveDirectOffer}
                canManageOffers={canManageOffers}
              />
              <RequestOfferList
                detail={detail}
                setPreviewAttachment={setPreviewAttachment}
                openOfferDocumentsId={openOfferDocumentsId}
                setOpenOfferDocumentsId={setOpenOfferDocumentsId}
                savingOffer={savingOffer}
                pendingOfferRemovalId={pendingOfferRemovalId}
                setPendingOfferRemovalId={setPendingOfferRemovalId}
                removingOfferId={removingOfferId}
                openOfferEditor={openOfferEditor}
                removeOffer={removeOffer}
                comparison={comparison}
                getOfferAttachments={getOfferAttachments}
                canManageOffers={canManageOffers}
              />
            </section>;
}
